import React from "react";
import { Col, Container, Row } from "react-bootstrap";

// {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - Start */}
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error) {
        console.error(`Error catched in ${this.props.componentName} component`, error);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className='zero-state-alerts zero-state-alerts-xl'>
                    <Container fluid className='g-0'>
                        <Row className='g-0'>
                            <Col className='justify-content-center align-items-center text-center'>
                                <div className='font-regular font-size4 color-text'>Something went wrong! Kindly refresh the page or try again after sometime.</div>
                            </Col>
                        </Row>
                    </Container>                   
                </div>
            );
        }

        return this.props.children;
    }
}

ErrorBoundary.defaultProps = {
    componentName: ''
};

export default ErrorBoundary;
// {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - End */}